export default __webpack_public_path__ + "static/media/catlike150000.b54d169f.png";